import { CSSProperties, JSX } from 'react';

import { ApplicationHelpType } from '../../utilities/Constants';
import { Help } from './Help';
import { IBaseSortModel } from '../../interfaces/PagedSortedSearch';
import SortData from './SortData';
import classNames from 'classnames';

export interface ISortableHeaderProps<T> {
    active?: boolean;
    currentSortModel?: IBaseSortModel<T>;
    dataObjectIdentifier?: number;
    headerComponent?: JSX.Element;
    justifyContent?: string | undefined;
    headerText?: string;
    helpTitle?: string;
    helpText?: string;
    noWrap?: boolean;
    onSort: (
        key: string,
        order: string,
        subKey?: string | undefined,
        subGrandKey?: string | undefined
    ) => void;
    showInfoButton?: boolean;
    sortKey: string;
    subGrandKey?: string | undefined;
    subKey?: string | undefined;
    thClassName?: string;
    thStyle?: CSSProperties | undefined;
}

export function SortableHeader<T>(props: ISortableHeaderProps<T>) {
    const {
        active,
        currentSortModel,
        dataObjectIdentifier,
        headerComponent,
        headerText,
        helpText,
        helpTitle,
        justifyContent,
        noWrap,
        onSort,
        showInfoButton,
        sortKey,
        subGrandKey,
        subKey,
        thClassName,
        thStyle,
    } = props;

    const thClass = classNames('sortable-header', thClassName);

    return (
        <th className={thClass} style={thStyle}>
            <div
                style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 3,
                    paddingRight: '5px',
                    justifyContent: justifyContent,
                }}
            >
                <div style={{ flex: '0 0', whiteSpace: noWrap ? 'nowrap' : 'normal' }}>
                    {headerComponent ? headerComponent : headerText}
                </div>
                <div style={{ flex: '0 0', paddingRight: 5 }}>
                    <SortData
                        active={active}
                        currentSortModel={currentSortModel}
                        fieldName={sortKey}
                        sortData={onSort}
                        subKey={subKey}
                        subGrandKey={subGrandKey}
                        stackControls
                        dataObjectIdentifier={dataObjectIdentifier}
                    />
                </div>
                {showInfoButton && (
                    <Help
                        type={ApplicationHelpType.Info}
                        title={helpTitle ?? ''}
                        helpText={helpText ?? ''}
                    />
                )}
            </div>
        </th>
    );
}
